import React from 'react'
import { AppBar, Toolbar, Button, Box } from '@material-ui/core'
import clsx from 'clsx'
import projectHeroLogo from '../../assets/projectHero_black_05.svg'
import { makeStyles } from '@material-ui/core/styles'
import { useAuth } from '../../providers'
import { useNavigate, useLocation } from 'react-router-dom'
import { Link } from '@material-ui/core'
import { CreateBookingButton } from '../../pages/MyBookings/components/CreateBookingButton'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { reactGAEvent } from '../../utils'

const useStyles = makeStyles((theme) => {
    return {
        appbar: {
            padding: theme.spacing(1),
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#fff',
        },
        header: {
            borderBottom: 'solid 1px #E5E7EB',
        },
        btn: {
            textTransform: 'none',
        },
        img: {
            maxWidth: '100%',
            width: theme.spacing(8),
            marginRight: theme.spacing(1),
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(10),
            },
        },
        navContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            maxWidth: '230px',
            alignItems: 'center',
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                maxWidth: '300px',
                justifyContent: 'flex-end',
                gap: theme.spacing(3),
            },
        },
        navArea: {
            display: 'flex',
            gap: '0.25rem',
            alignItems: 'center',
            width: '100%',
            justifyContent: ({ currRoute }) =>
                ['/login', '/otpverification', '/register'].includes(currRoute) ? 'center' : 'space-between',
            [theme.breakpoints.up('sm')]: {
                width: '80%',
                margin: 'auto',
                justifyContent: 'space-between!important',
            },
        },
        stickToRight: {
            marginLeft: 'auto',
        },
    }
})

export const Header = () => {
    const location = useLocation()
    const currRoute = location?.pathname
    const classes = useStyles({ currRoute })
    const navigate = useNavigate()
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up('sm'))

    const { logout, isUserLoggedIn } = useAuth()

    const handleClick = () => {
        if (isUserLoggedIn) {
            reactGAEvent('Button', 'Log Out button clicked')
            return logout()
        }

        reactGAEvent('Button', 'Log In button clicked')
        navigate('/login', {
            state: { from: location.pathname },
        })
    }

    const publicRoutes = ['/login', '/otpverification', '/register']

    const onMyBookingsClicked = () => {
        reactGAEvent('Button', 'My Bookings button clicked')
        navigate('/')
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="sticky" elevation={0} className={classes.header}>
                <Toolbar className={classes.appbar} variant="dense">
                    <div className={classes.navArea}>
                        <Link href="/">
                            <img className={classes.img} src={projectHeroLogo} alt="project hero" />
                        </Link>
                        {!publicRoutes.includes(location.pathname) && (
                            <div className={classes.navContainer}>
                                {location.pathname === '/' && matches && <CreateBookingButton />}
                                {isUserLoggedIn && location.pathname !== '/' && (
                                    <Button
                                        className={classes.btn}
                                        color="secondary"
                                        variant="outlined"
                                        size="medium"
                                        onClick={onMyBookingsClicked}
                                    >
                                        {'My Bookings'}
                                    </Button>
                                )}

                                {isUserLoggedIn && (
                                    <Button
                                        className={clsx(classes.btn)}
                                        // variant={"outlined"}
                                        style={{ marginLeft: 'auto' }}
                                        color={isUserLoggedIn ? 'default' : 'primary'}
                                        size="medium"
                                        onClick={handleClick}
                                    >
                                        {isUserLoggedIn ? 'LOG OUT' : 'LOG IN'}
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                </Toolbar>
            </AppBar>
        </Box>
    )
}
